// import React, { useEffect, useState } from "react";
// import "./RDDDPreClosure.css";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import axios from "axios";
// import { toast } from "react-toastify";

// const API_URL = "https://payyug.in/api";

// const RDDDPreClosure = () => {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   const [accounts, setAccounts] = useState([]);
//   const [selectedAccount, setSelectedAccount] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [showPreview, setShowPreview] = useState(false); 

//   const [formData, setFormData] = useState({
//     amount: "",
//     transactionType: "",
//     paymentMode: "CASH",
//     transactionDate: "",
//     narration: "",
//   });

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);
 
// //    const fetchAccounts = async () => {
// //       try {
// //         const res = await axios.get(`${API_URL}/get-all-saving-account`, {
// //           params: {
// //             superAdminId: profile.superAdminId || 14,
// //             branchId: profile.branchId || 8,
// //             createdBy: localStorage.getItem("userId"),
// //           },
// //         });
// //         setAccounts(res.data?.accounts || []);
// //       } catch (err) {
// //         toast.error(err?.response?.data?.message || "Failed to fetch accounts");
// //       }
// //     };

//     const fetchAccounts = async () => {
//         try {
//          // setLoading(true);
//           const superAdminId = profile.superAdminId || 14;
//           const branchId = localStorage.getItem("userId") || 56;
    
//           const res = await axios.get("https://payyug.in/api/deposit/list", {
//             params: {
//               superAdminId,
//               branchId,
//              // status: activeSecondary !== "All" ? activeSecondary : undefined,
//               // search: searchQuery || undefined,
//             },
//           });
    
//         //   console.log("deposit list:",res)
//           if (res.data.success) {
//             setAccounts(res.data.data || []);
            
//           } else {
//             setAccounts([]);
//           }
//         } catch (err) {
//           console.error("Error fetching deposit accounts:", err);
//           setAccounts([]);
//         } finally {
//           //setLoading(false);
//         }
//       };

//   useEffect(() => {
   
//     if (profile) fetchAccounts();
//   }, [profile]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   /* ================= VALIDATION & PREVIEW ================= */
//   const handlePreview = (e) => {
//     e.preventDefault();
//     if (!selectedAccount) return toast.warn("Please select saving account");
//     if (!formData.amount || !formData.transactionType || !formData.transactionDate) {
//       return toast.warn("Please fill all required fields");
//     }
//     if (formData.transactionType === "WITHDRAWAL" && Number(formData.amount) > Number(selectedAccount.amount)) {
//       return toast.warn("Withdrawal amount exceeds available balance");
//     }
//     setShowPreview(true);
//   };

//   /* ================= FINAL SUBMIT ================= */
//   const handleSubmit = async () => {
//     try {
//       const payload = {
//         accountId: selectedAccount.id,
//         withdrawAmount: Number(formData.amount),
//         // transactionType: formData.transactionType,
//         withdrawMode: formData.paymentMode,
//         // transactionDate: formData.transactionDate,
//         remarks: formData.narration,
//         // status: "Paid",
//         // employeeId: localStorage.getItem("userId"),
//         withdrawnBy: localStorage.getItem("userId"),
//       };

//       // const url = formData.transactionType === "DEPOSIT" 
//       //   ? "/saving-account/bank/deposit" 
//       //   : "/saving-account/bank/withdraw";
//       const url="/deposit/pay/withdraw";

//       const res = await axios.post(`${API_URL}${url}`, payload);
//       toast.success(res?.data?.message || "Transaction successful");

//       setFormData({ amount: "", transactionType: "", paymentMode: "CASH", transactionDate: "", narration: "" });
//       setSelectedAccount(null);
//       setShowPreview(false);
//       if (profile) fetchAccounts();
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Transaction failed");
//     }
//   };

//   useEffect(() => {
//     const fetchKyc = async () => {
//       if (selectedAccount?.customerId) {
//         try {
//           const res = await axios.get(`${API_URL}/list-kyc`, {
//             params: { userId: selectedAccount.customerId, createdId: profile.id }
//           });
//           setUploadedKyc(res.data.documents || []);
//         } catch {
//           setUploadedKyc([]);
//         }
//       }
//     };
//     fetchKyc();
//   }, [selectedAccount, profile?.id]);

//   return (
//     <div className="saving-account-transaction-container">
//       <h2>RD DD Transaction Portal</h2>

//       <form className="saving-account-transaction-payment-details" onSubmit={handlePreview}>
//         <h4><i className="fa-solid fa-shield-halved"></i> Payment Details</h4>
        
//         <div className="payment-details-container">
//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>RD/DD Account</label>
//               <Select
//                 className="account-select-container"
//                 classNamePrefix="account-select"
//                 placeholder="Search by Name or A/C No..."
//                 options={accounts.map((acc) => ({
//                   value: acc.id,
//                   label: `${acc.customerName} | ${acc.accountNo}`,
//                   account: acc
//                 }))}
//                 value={selectedAccount ? { value: selectedAccount.id, label: `${selectedAccount.customerName} | ${selectedAccount.accountNo}` } : null}
//                 onChange={(selected) => setSelectedAccount(selected?.account)}
//                 isSearchable
//               />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Available Balance</label>
//               <input type="text" value={`₹ ${selectedAccount?.amount || "0.00"}`} readOnly />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Pre Closure ROI(%)</label>
//               <input type="text" value={`${selectedAccount?.roi || "0.00"}%`} readOnly />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Principal Amount</label>
//               <input type="text" value={`₹ ${selectedAccount?.principalAmount || "0.00"}`} readOnly />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Interest Amount</label>
//               <input type="text" value={`₹ ${selectedAccount?.totalInterest || "0.00"}`} readOnly />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Maturity Amount</label>
//               <input type="text" value={`₹ ${selectedAccount?.maturityAmount || "0.00"}`} readOnly />
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Amount (INR)</label>
//               <input type="number" name="amount" value={formData.amount} onChange={handleChange} placeholder="0.00" />
//             </div>
//             <div className="payment-details-inputs">
//               <label>Transaction Type</label>
//               <select name="transactionType" value={formData.transactionType} onChange={handleChange}>
//                 {/* <option value="">Select Type</option> */}
//                 {/* <option value="DEPOSIT">DEPOSIT</option> */}
//                 <option value="WITHDRAWAL"> Pre Closure WITHDRAWAL</option>
//               </select>
//             </div>
//           </div>

//           <div className="payment-details-input-groups">
//             <div className="payment-details-inputs">
//               <label>Payment Mode</label>
//               <select name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
//                 <option value="CASH">CASH</option>
//                 <option value="UPI">UPI</option>
//                 <option value="RTGS">NEFT RTGS</option>
//                 </select>
//             </div>
//             <div className="payment-details-inputs">
//               <label>Transaction Date</label>
//               <input type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
//             </div>
//           </div>
//         </div>

//           <div className="payment-details-input-groups">
//              <div className="payment-details-inputs">
//               <label>Narration</label>
//               <input
//               type="text"
//                 name="narration"
//                value={formData.narration}
//                 onChange={handleChange}
//                 placeholder="Optional narration"
//               />
//             </div>
//           </div>
        

//         <div className="kyc-section-title">Verified Documents</div>
//         <div className="kyc-cards-container">
//           {uploadedKyc.length === 0 ? <p className="no-kyc">No KYC documents found for this account</p> : 
//             uploadedKyc.map((doc, index) => (
//               <div className="kyc-card" key={index}>
//                 <img src={`https://payyug.in/uploads/${doc.docImage}`} alt="KYC" className="kyc-image" onClick={() => window.open(`https://payyug.in/uploads/${doc.docImage}`, "_blank")} />
//                 <p className="doctitle">{doc.docName || "Document"}</p>
//               </div>
//             ))
//           }
//         </div>

//         <div className="pay-btn">
//           <button type="submit">Verify & Process Transaction</button>
//         </div>
//       </form>

//       {/* ================= PREVIEW MODAL ================= */}
//       {showPreview && (
//         <div className="modal-overlay">
//           <div className="transaction-modal">
//             <h3>Confirm Transaction</h3>
//             <div className="modal-content">
//               <div className="modal-row"><span>Account:</span> <strong>{selectedAccount.customerName}</strong></div>
//               <div className="modal-row"><span>A/C Number:</span> <strong>{selectedAccount.accountNo}</strong></div>
//               <div className="modal-row"><span>Type:</span> <strong className={formData.transactionType}>{formData.transactionType}</strong></div>
//               <div className="modal-row amount-row"><span>Amount:</span> <strong>₹ {formData.amount}</strong></div>
//             </div>
//             <div className="modal-actions">
//               <button className="cancel-btn" onClick={() => setShowPreview(false)}>Edit</button>
//               <button className="confirm-btn" onClick={handleSubmit}>Confirm Payment</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RDDDPreClosure;


import React, { useEffect, useState } from "react";
import "./RDDDPreClosure.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const RDDDPreClosure = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  // State for calculation breakdown
  const [calcResults, setCalcResults] = useState({
    daysDiff: 0,
    interest: 0,
    maturity: 0,
    penalty: 0 // Added penalty state if needed for your UI
  });

  const [formData, setFormData] = useState({
    amount: "",
    transactionType: "WITHDRAWAL",
    paymentMode: "CASH",
    transactionDate: new Date().toISOString().split("T")[0],
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchAccounts = async () => {
    try {
      const superAdminId = profile.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;

      const res = await axios.get(`${API_URL}/deposit/list`, {
        params: { superAdminId, branchId },
      });

      if (res.data.success) {
        setAccounts(res.data.data || []);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching deposit accounts:", err);
      setAccounts([]);
    }
  };

  useEffect(() => {
    if (profile) fetchAccounts();
  }, [profile]);

  /* ================= PRE-CLOSURE CALCULATION ================= */
  useEffect(() => {
    if (selectedAccount && formData.transactionDate) {
      const openDate = new Date(selectedAccount.openingDate);
      const closeDate = new Date(formData.transactionDate);
      
      // Calculate Days
      const diffTime = closeDate - openDate;
      const diffDays = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));

      const principal = Number(selectedAccount.totalDeposited || 0);
      const roi = Number(selectedAccount?.scheme?.preClosureRoi || 0);
      const penalty = Number(selectedAccount.penaltyAmount || 0); // Assuming penalty might come from account data

      // Simple Interest Formula for the period: (P * R * (Days/365)) / 100
      const calculatedInterest = (principal * roi * (diffDays / 365)) / 100;
      const finalMaturity = (principal + calculatedInterest) - penalty;

      setCalcResults({
        daysDiff: diffDays,
        interest: calculatedInterest.toFixed(2),
        maturity: finalMaturity.toFixed(2),
        penalty: penalty.toFixed(2)
      });

      // Update the form amount automatically
      setFormData(prev => ({ ...prev, amount: finalMaturity.toFixed(2) }));
    }
  }, [selectedAccount, formData.transactionDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePreview = (e) => {
    e.preventDefault();
    if (!selectedAccount) return toast.warn("Please select an account");
    if (!formData.amount || !formData.transactionDate) {
      return toast.warn("Please fill all required fields");
    }
    setShowPreview(true);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        accountId: selectedAccount.id,
        preCloseAmount: Number(formData.amount),
        interest: Number(calcResults.interest),
        penaltyAmount: Number(calcResults.penalty),
        totalDeposited: Number(selectedAccount.principalAmount || 0),
        closedBy: localStorage.getItem("userId") || profile.id,
        remarks: formData.narration || "Customer requested early closure"
      };

      // Updated API endpoint per your request
      const res = await axios.post(`${API_URL}/deposit/preclose/amount`, payload);
      
      toast.success(res?.data?.message || "Pre-closure completed successfully");

      // Reset form
      setFormData({ 
        amount: "", 
        transactionType: "WITHDRAWAL", 
        paymentMode: "CASH", 
        transactionDate: new Date().toISOString().split("T")[0], 
        narration: "" 
      });
      setSelectedAccount(null);
      setShowPreview(false);
      fetchAccounts();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Pre-closure request failed");
    }
  };

  useEffect(() => {
    const fetchKyc = async () => {
      if (selectedAccount?.customerId) {
        try {
          const res = await axios.get(`${API_URL}/list-kyc`, {
            params: { userId: selectedAccount.customerId, createdId: profile.id }
          });
          setUploadedKyc(res.data.documents || []);
        } catch {
          setUploadedKyc([]);
        }
      }
    };
    fetchKyc();
  }, [selectedAccount, profile?.id]);

  return (
    <div className="saving-account-transaction-container">
      <h2>RD DD Pre-Closure Portal</h2>

      <form className="saving-account-transaction-payment-details" onSubmit={handlePreview}>
        <h4><i className="fa-solid fa-shield-halved"></i> Payment Details</h4>
        
        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>RD/DD Account</label>
              <Select
                className="account-select-container"
                classNamePrefix="account-select"
                placeholder="Search by Name or A/C No..."
                options={accounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNo}`,
                  account: acc
                }))}
                value={selectedAccount ? { value: selectedAccount.id, label: `${selectedAccount.customerName} | ${selectedAccount.accountNo}` } : null}
                onChange={(selected) => setSelectedAccount(selected?.account)}
                isSearchable
              />
            </div>
            <div className="payment-details-inputs">
              <label>Total Deposited (Principal)</label>
              <input type="text" value={`₹ ${selectedAccount?.totalDeposited || "0.00"}`} readOnly />
            </div>
          </div>

        

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Account Opening Date</label>
              <input
                  type="text"
                  value={
                    selectedAccount?.openingDate
                      ? new Date(selectedAccount.openingDate).toLocaleDateString("en-IN")
                      : ""
                  }
                  readOnly
                />
            </div>
            <div className="payment-details-inputs">
              <label>Pre-Closure ROI (%)</label>
              <input type="text" value={`${selectedAccount?.scheme?.preClosureRoi || "0.00"}%`} readOnly style={{fontWeight: 'bold', color: '#2c3e50'}}/>
            </div>
           
            
          </div>

          {/* <div className="payment-details-input-groups">
             <div className="payment-details-inputs">
              <label>Days Active</label>
              <input type="text" value={`${calcResults.daysDiff} Days`} readOnly />
            </div>
            <div className="payment-details-inputs">
              <label>Penalty Amount</label>
              <input type="text" value={`₹ ${calcResults.penalty}`} readOnly style={{color: '#d9534f'}} />
            </div>
          </div> */}

          <div className="payment-details-input-groups">
             <div className="payment-details-inputs">
              <label>Accrued Interest</label>
              <input type="text" value={`₹ ${calcResults.interest}`} readOnly style={{backgroundColor: '#f8f9fa'}} />
             </div>
            <div className="payment-details-inputs">
              <label>Pre-Closure Maturity Amount</label>
              <input type="text" value={`₹ ${calcResults.maturity}`} readOnly style={{backgroundColor: '#e8f5e9', fontWeight: 'bold'}} />
            </div>
           
          </div>

          <div className="payment-details-input-groups">
            {/* <div className="payment-details-inputs">
              <label>Final Amount (Payable)</label>
              <input type="number" name="amount" value={formData.amount} onChange={handleChange} placeholder="0.00" />
            </div> */}
             <div className="payment-details-inputs">
              <label>Transaction Date</label>
              <input type="date" name="transactionDate" value={formData.transactionDate} onChange={handleChange} />
            </div>
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
                <option value="CASH">CASH</option>
                <option value="UPI">UPI</option>
                <option value="RTGS">NEFT RTGS</option>
              </select>
            </div>
          </div>
          
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Narration / Remarks</label>
              <input type="text" name="narration" value={formData.narration} onChange={handleChange} placeholder="Customer requested early closure" />
            </div>
          </div>
        </div>

        <div className="kyc-section-title">Verified Documents</div>
        <div className="kyc-cards-container">
          {uploadedKyc.length === 0 ? <p className="no-kyc">No KYC documents found for this account</p> : 
            uploadedKyc.map((doc, index) => (
              <div className="kyc-card" key={index}>
                <img 
                  src={`https://payyug.in/uploads/${doc.docImage}`} 
                  alt="KYC" 
                  className="kyc-image" 
                  onClick={() => window.open(`https://payyug.in/uploads/${doc.docImage}`, "_blank")} 
                />
                <p className="doctitle">{doc.docName || "Document"}</p>
              </div>
            ))
          }
        </div>

        <div className="pay-btn">
          <button type="submit">Verify & Process Pre-Closure</button>
        </div>
      </form>

      {showPreview && (
        <div className="modal-overlay">
          <div className="transaction-modal">
            <h3>Confirm Pre-Closure</h3>
            <div className="modal-content">
              <div className="modal-row"><span>Account:</span> <strong>{selectedAccount.customerName}</strong></div>
              <div className="modal-row"><span>Total Deposited:</span> <strong>₹ {selectedAccount.totalDeposited}</strong></div>
              <div className="modal-row"><span>Interest:</span> <strong>₹ {calcResults.interest}</strong></div>
              <div className="modal-row"><span>Penalty:</span> <strong style={{color: 'red'}}>₹ {calcResults.penalty}</strong></div>
              <div className="modal-row amount-row"><span>Total Settlement:</span> <strong>₹ {formData.amount}</strong></div>
            </div>
            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowPreview(false)}>Edit</button>
              <button className="confirm-btn" onClick={handleSubmit}>Confirm Payment</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDDDPreClosure;